import type { TourDefinition } from "@/types/tour";

function openReportDropdown() {
  const trigger = document.querySelector<HTMLElement>(
    '[data-tour-id="committee-report-button"]'
  );
  if (trigger) trigger.click();
}

function closeReportDropdown() {
  document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true }));
}

export const committeePrePackageTour: TourDefinition = {
  id: "committee-pre-package",
  context: "terminus-admin",
  version: 1,
  manual: true,
  steps: [
    {
      element: '[data-tour-id="committee-pre-report-bar"]',
      popover: {
        title: "Pre-Committee Report",
        description:
          "Tracks how many opportunities and solution lines are ready for review. The status bar turns green once you have at least one opportunity.",
      },
    },
    {
      element: '[data-tour-id="committee-report-button"]',
      popover: {
        title: "Download & regenerate",
        description:
          "Once a report exists you can download the current document or force a full regeneration with the latest data.",
      },
      onHighlightStarted: openReportDropdown,
      onDeselected: closeReportDropdown,
    },
    {
      element: '[data-tour-id="committee-pre-market-insights"]',
      popover: {
        title: "Market Insights",
        description:
          "Attach relevant market insights to give the committee broader context alongside the opportunities.",
      },
    },
    {
      element: '[data-tour-id="committee-pre-opportunities"]',
      popover: {
        title: "Opportunities",
        description:
          "Add the opportunities you want the committee to review. Each one carries its solution lines and solutions into the report.",
      },
    },
  ],
};
